// TODO: [subdomain-urls]
import { getEnvFromSubdomain } from 'helpers/UrlHelper';
import { getCustomAPISubdmomain } from 'helpers/UrlHelper';

const BASE_CONSTANTS = {};

const envFromSubdomain = getEnvFromSubdomain() ? `${getEnvFromSubdomain()}-` : '';
const customAPISubdmomain = getCustomAPISubdmomain() ? `${getCustomAPISubdmomain()}-` : '';
const environment = envFromSubdomain || customAPISubdmomain;

const LOCAL_CONSTANTS = {
  ENV: 'local',
  BASE_API_URL: `http://${environment}api.localhost`,
};

const QA_CONSTANTS = {
  ENV: 'qa',
  BASE_API_URL: `https://${environment}api.${window.CLIENT_URL}`,
};

const STAGING_CONSTANTS = {
  ENV: 'staging',
  BASE_API_URL: `https://${environment}api.${window.CLIENT_URL}`,
};

const TRAINING_CONSTANTS = {
  ENV: 'training',
  BASE_API_URL: `https://${environment}api.${window.CLIENT_URL}`,
};

const PROD_CONSTANTS = {
  ENV: 'production',
  BASE_API_URL: `https://${environment}api.${window.CLIENT_URL}`,
};

function getEnv() {
  const hostParts = window.location.hostname.split('.');
  let [subdomain, hostname] = hostParts.length === 1 ? [null, hostParts[0]] : hostParts;

  if (envFromSubdomain) {
    subdomain = subdomain.replace(envFromSubdomain, '');
  }
  const URL_CONSTANTS = {
    SUBDOMAIN: subdomain,
    HOSTNAME: hostname,
    CLIENT_HOSTNAME: subdomain && subdomain !== 'app' ? subdomain : hostname,
  };
  const BASE_URL = `https://${subdomain}.${window.CLIENT_URL}`;

  if (window.ENV === 'production') {
    return {
      ...BASE_CONSTANTS,
      ...PROD_CONSTANTS,
      ...URL_CONSTANTS,
      BASE_URL,
    };
  } else if (window.ENV === 'dev') {
    return {
      ...BASE_CONSTANTS,
      ...QA_CONSTANTS,
      ...URL_CONSTANTS,
      BASE_URL,
    };
  } else if (window.ENV === 'qa') {
    return {
      ...BASE_CONSTANTS,
      ...QA_CONSTANTS,
      ...URL_CONSTANTS,
      BASE_URL,
    };
  } else if (window.ENV === 'staging') {
    return {
      ...BASE_CONSTANTS,
      ...STAGING_CONSTANTS,
      ...URL_CONSTANTS,
      BASE_URL,
    };
  } else if (window.ENV === 'training') {
    return {
      ...BASE_CONSTANTS,
      ...STAGING_CONSTANTS,
      ...TRAINING_CONSTANTS,
      ...URL_CONSTANTS,
      BASE_URL,
    };
  } else if (window.ENV === 'development' || !window.ENV) {
    const BASE_URL = `${subdomain ? `${subdomain}.` : ''}${hostname}`;
    return {
      ...BASE_CONSTANTS,
      ...LOCAL_CONSTANTS,
      ...URL_CONSTANTS,
      BASE_URL,
    };
  }
}

export default getEnv();
